import { render, staticRenderFns } from "./MessageForeign.vue?vue&type=template&id=5ccfc96e&"
import script from "./MessageForeign.vue?vue&type=script&lang=js&"
export * from "./MessageForeign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports